import { PlcItem, VariableItem } from "@/template/interface"
import { message } from "antd"

/**
 * 获取数据类型最大位数(整数位 + 小数位)
 * @param dataTypeValue
 */
export function getMaxDigits(dataTypeValue: number) {
  var maxDigits = 0
  switch (dataTypeValue) {
    case 1:
    case 2:
      maxDigits = 5
      break
    case 11:
    case 12:
      maxDigits = 10
      break
    case 3:
    case 4:
      maxDigits = 4
      break
    case 13:
    case 14:
      maxDigits = 8
      break
    case 5:
      maxDigits = 16
      break
    case 15:
      maxDigits = 32
      break
    case 16:
    case 26:
      maxDigits = 10

    case 21:
    case 22:
    case 23:
    case 24:
    case 25:
      maxDigits = 10

      break
  }

  return maxDigits
}

/**
 * 获取地址显示格式
 * @param address
 * @param type
 * @returns
 */
export function getAddressFormat(address?: number, type?: number) {
  let ret = ''
  let a
  let b = ''
  switch (type) {
    case 8:
      a = address?.toString(8)
      b = 'O'
      break
    case 10:
      a = address?.toString(10)
      b = 'D'
      break
    case 16:
      a = address?.toString(16)
      b = 'H'
      break
  }
  for (var i = 0; i < a.length; i++) {
    ret += b
  }
  return ret
}

export function checkDigits(
  dataType: number,
  integerDigits: number,
  fractionDigits: number
): boolean {
  const max = getMaxDigits(dataType)
  if (integerDigits + fractionDigits <= 0) {
    message.error('整数位和小数位不能同时为0')
    return false
  }

  if (integerDigits + fractionDigits > max) {
    message.error(`整数位和小数位之和不能超过${max}`)
    return false
  }
  return true
}

export function getAddressName(item: VariableItem, plcs?: PlcItem[]): string {
  const plc = plcs?.find((x) => x.id == item.deviceId)
  const reg = plc?.registers?.find((x) => x.name == item.registerName)
  let addr = `${item.registerName} ${item.mainAddress}`
  if (reg?.hasSubAddress) {
    addr += `.${item.subAddress}`
  }
  if (reg?.hasSubIndex) {
    addr += `.${item.subIndex}`
  }
  if (item.enabledIndex) {
    addr += `.${item.bitIndex}`
  }
  return addr
}

export function getAddressOption(item: VariableItem, plcs?: PlcItem[]) {
  const addr = getAddressName(item, plcs)
  return `${item.name}(${addr})`
}
